import HeroSectionImplementation from '../implementation/sections/HeroSection';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import {
  StrapiHeroSectionDTO,
  HeroSectionDTO,
} from '@lib/strapi/dtos/components/sections/heroSection.dto';

const HeroSection = (props: ComponentProps<HeroSectionDTO>) => {
  return <HeroSectionImplementation {...props}></HeroSectionImplementation>;
};

export default HeroSection;
